import {apiDELETE, apiGET, apiPOST, apiPUT} from "./RequestsCore";

/**
 * Creates a new status with the provide data from the provided expedient.
 *
 * @param expedient_id
 * @param status
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createExpedientStatus(expedient_id, status) {
    return await apiPOST('/api/expedient/' + expedient_id + '/status', status);
}

/**
 * Returns the existing statuses that are allowed for the user who requests.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getStatuses() {
    return await apiGET('/api/statuses');
}

/**
 * Returns all the existing statuses.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getAllStatuses() {
    return await apiGET('/api/all-statuses');
}

/**
 * Deletes the provided status from the provided expedient.
 *
 * @param expedient
 * @param status
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteExpedientStatus(expedient, status) {
    return await apiDELETE('/api/expedient/' + expedient.id + '/status/' + status.id);
}

/**
 * Updates the provided status from the provided expedient.
 *
 * @param expedient
 * @param status
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function editExpedientStatus(expedient, status) {
    return await apiPUT('/api/expedient/' + expedient.id + '/status/' + status.id, status);
}

export async function getExpedientStatus(expedient) {
    return await apiGET('/api/expedient/' + expedient + '/statuses');
}

/**
 * Gets the observations from the provided expedient
 * 
 * @param expedientId
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function getExpedientObservations(expedientId) {
    return await apiGET('/api/expedient/' + expedientId + '/observations');
}

/**
 * Updates the provided observations in the provided expedient.
 *
 * @param expedientId
 * @param observations
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function updateExpedientObservations(expedientId, observations) {
    return await apiPUT('/api/expedient/' + expedientId + '/observations', {observations});
}
